import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { Sparkles, Coins, Disc3, Gift, Wallet } from 'lucide-react';
import { SpinPanel } from '@/components/spin/SpinPanel.js';
import { BonusSectionHeader } from '@/components/promo/BonusSectionHeader.js';
import { HowItWorksModal, type HowItWorksStep } from '@/components/promo/HowItWorksModal.js';
import { SPIN_QUERY_KEYS, fetchSpinEvent } from '@/features/spin/api.js';
import { useMoneyCurrency } from '@/components/money/MoneyProvider.js';

export function LuckySpinSection() {
  const { t } = useTranslation('spin');
  const [showTutorial, setShowTutorial] = useState(false);
  const currency = useMoneyCurrency();

  const eventQuery = useQuery({
    queryKey: SPIN_QUERY_KEYS.event,
    queryFn: fetchSpinEvent,
    staleTime: 15_000,
  });
  const available = !!eventQuery.data?.available;

  const steps: HowItWorksStep[] = [Coins, Disc3, Gift, Wallet].map((icon, i) => ({
    icon,
    title: t(`tutorial.step${i + 1}.title`),
    body: t(`tutorial.step${i + 1}.body`),
  }));

  return (
    <div className="flex flex-col gap-5">
      <BonusSectionHeader
        title={t('title')}
        subtitle={t('subtitle')}
        onHowTo={() => setShowTutorial(true)}
        historyTab="spin"
      />

      {available ? (
        <SpinPanel currency={currency} />
      ) : (
        <section className="rounded-2xl border border-[var(--border)] bg-[var(--bg-raised)] py-14 flex flex-col items-center gap-3 text-center">
          <div className="w-12 h-12 rounded-full bg-[var(--bg-elevated)] flex items-center justify-center">
            <Sparkles size={22} className="text-[var(--text-muted)]" />
          </div>
          <p className="text-[13px] text-[var(--text-muted)]">{t('unavailable')}</p>
        </section>
      )}

      <HowItWorksModal open={showTutorial} onClose={() => setShowTutorial(false)} steps={steps} />
    </div>
  );
}
